import {init} from '@plausible-analytics/tracker';
import type {PlausibleConfig} from '@plausible-analytics/tracker';

const STORAGE_KEY = 'primus.client.main';
const FALLBACK_MUSEUM_LABEL = 'no-backend';
let plausibleInitialized = false;

const readMuseumFromStorage = () => {
  // In tests and dev-tooling windows is not defined - immediately return the fallback label.
  if (typeof window === 'undefined') {
    return FALLBACK_MUSEUM_LABEL;
  }

  // Nothing in localStorage / Museum not selected yet - return fallback label.
  const raw = window.localStorage.getItem(STORAGE_KEY);
  if (!raw) {
    return FALLBACK_MUSEUM_LABEL;
  }

  try {
    // Museum selected - try to parse and return its name or shortName - fallback to default label if parsing fails. 
    const parsed = JSON.parse(raw) as {name?: string; shortName?: string};
    const fallback = parsed?.name ?? parsed?.shortName ?? FALLBACK_MUSEUM_LABEL;
    return fallback;
  } catch {
    return FALLBACK_MUSEUM_LABEL;
  }
};

export function initPlausible(config?: PlausibleConfig): void {
  if (plausibleInitialized || !config?.domain) {
    return;
  }

  plausibleInitialized = true;

  init({
    ...config,
    customProperties: () => ({
      museum: readMuseumFromStorage(),
    }),
  });
}
